import { NextApiResponse } from "next";
import axiosClient from "./axios";
import { AxiosRequestConfig } from "axios";

async function get<T>(
  path: string,
  headers?: Record<string, string | number | boolean>,
  withCredentials?: boolean
): Promise<T> {
  const res = await axiosClient
    .get<T>(path, { headers, withCredentials })
    .then((response) => response.data);

  return res;
}

async function post<T>(
  path: string,
  data?: AxiosRequestConfig["data"],
  headers?: AxiosRequestConfig["headers"]
): Promise<T> {
  const res = await axiosClient
    .post<T>(path, data, { headers })
    .then((response) => response.data);

  return res;
}

async function put<T>(
  path: string,
  data: string | number | boolean,
  headers?: Record<string, string | number | boolean>
): Promise<T> {
  const res = await axiosClient
    .put<T>(path, data, { headers })
    .then((response) => response.data);

  return res;
}

export const CACHE_TIME_DEFAULT = 60 * 60 * 2;
export function setCacheControlHeader(
  res: NextApiResponse,
  seconds: number = CACHE_TIME_DEFAULT
): void {
  res.setHeader("Cache-Control", `max-age=${seconds}, stale-while-revalidate`);
}

const request = {
  get,
  post,
  put,
};

export default request;
